export default __webpack_public_path__ + "static/777-04bf6da589fe321faf9efc0f01265ed4.gif";